module.exports = __webpack_public_path__ + "static/media/get_more_img_2.3b59feff.svg";